const PROTOCOL = "https";  //服务器用
// const PROTOCOL = "http";  //本地调试用

const PORT = 80;

// const HOST = "101.201.209.253/ra/raapi/public";   //服务器用
const HOST = "ra.criponline.com/raapi/public";   //服务器用
// const HOST = "sle.criponline.com/sleApi/public";   //服务器用
// const HOST = "localhost:8089";  //本地调试用

/**
 * 全局变量定义 
 */
export class GlobalVariable {
    private static sessionID: string;
    private static macKey: string = "3968412890132567";               //加密解密用的随机字符串 
    private static token: string;                    //访问服务端Token 
    private static baseUrl: string;
    private static auth_token: string;
    private static user_id: string;
    private static organ_id: string;
    private static deviceID: string;                 //设备ID 
    private static lastPageName: string;
    private static username: string;

    public static setLastPageName(lastPageName: string) {
        this.lastPageName = lastPageName;
    }

    public static getLastPageName() {
        return this.lastPageName;
    }

    public static setUserName(username: string) {
        this.username = username;
    }

    public static getUserName() {
        return this.username;
    }

    public static getBaseUrl() {
        return this.baseUrl = `${PROTOCOL}://${HOST}/`;
    }

    public static getSessionID() {
        if (this.sessionID == undefined) {
            this.sessionID = "";
        }
        return this.sessionID;
    }

    public static setSessionID(sessionID: string) {
        this.sessionID = sessionID;
    }

    public static setDeviceID(deviceID: string) {
        this.deviceID = deviceID;
    }

    public static getDeviceID() {
        return this.deviceID;
    }


    public static setMacKey(macKey: string) {
        this.macKey = macKey;
    }

    public static getMacKey() {
        return this.macKey;
    }


    public static getToken() {
        return this.token;
    }

    public static setToken(token: string) {
        this.token = token;
    }

    public static getAuthToken() {
        return this.auth_token;
    }

    public static setAuthToken(auth_token: string) {
        this.auth_token = auth_token;
    }

    public static clearAuthToken() {
        this.auth_token = null;
    }

    public static getUserID() {
        return this.user_id;
    }

    public static setUserID(user_id: string) {
        this.user_id = user_id;
    }

    public static getOrganID() {
        return this.organ_id;
    }

    public static setOrganID(organ_id: string) {
        this.organ_id = organ_id;
    }

}